<template>


    <div class="py-4 px-5">


        <div class="form-group row">
            <label for="facebook" class="col-sm-4 col-form-label text-left d-flex align-items-center fw-600">Facebook</label> 
            <div class="col-sm-8">
                <div class="input-group">
                    <span class="input-group-addon">https://www.facebook.com/</span>
                    <input type="text" class="form-control" id="facebook" v-model="data.facebook">
                </div>
            </div>
         </div>

        <div class="form-group row">
            <label for="twitter" class="col-sm-4 col-form-label text-left d-flex align-items-center fw-600">Twitter</label> 
            <div class="col-sm-8">
                <div class="input-group">
                    <span class="input-group-addon">https://www.twitter.com/</span>
                    <input type="text" class="form-control" id="twitter" v-model="data.twitter">
                </div>
            </div>
        </div>

        <div class="form-group row">
            <label for="instagram" class="col-sm-4 col-form-label text-left d-flex align-items-center fw-600">Instagram</label> 
            <div class="col-sm-8">
                <div class="input-group">
                    <span class="input-group-addon">https://www.instagram.com/</span>
                    <input type="text" class="form-control" id="instagram" v-model="data.instagram">
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12 text-left">
                <strong>Notice: </strong> It is imparitive that you only put what is after the URL for each. <br /> <br />

                <strong>Example: </strong> If your profile is accessible via this link: <code>https://www.facebook.com/bamastormchaser</code>, you would <strong>only</strong> enter <code>bamastormchaser</code> into the box.
            </div>
        </div>


        <div class="form-group row">
            <div class="col-sm-12 text-right mt-4">
                <button class="btn btn-secondary mr-3" v-on:click="previous">Previous</button>
                <button class="btn btn-primary" v-on:click="next">Next</button>
            </div>
        </div>

    </div>

</template>

<script>

    import { EventBus } from '../../utils/events'
    import * as Config from '../../config'
    import { mapState, mapGetters } from 'vuex';

	export default {
        name: 'Social',
		data () {
			return {
                msg: 'Welcome to Your Vue.js App',
                data: {
                    facebook: null,
                    instagram: null,
                    twitter: null,
                },
                loading: false,
			}
        },
        methods: {
            ...mapGetters([
                'getAuthorizationHeader',
            ]),
            previous() {
                var data = {
                    at: 'social',
                    direction: 'backward',
                }
                EventBus.$emit('account-setup-navigation', data)
            },
            next() {
                this.loading = true;
                var data = {
                    at: 'social',
                    direction: 'forward',
                }

                var _this = this;
                this.$http.post(Config.apiPath + "/api/v2/user/settings/update", this.data, this.getAuthorizationHeader()).then((response) => {
                    if(response.status == 200) {
                        this.loading = false;
                        EventBus.$emit('account-setup-navigation', data)

                    } else {
                        this.loading = false;
                        alert('There has been an issue. Please try again.');
                    }
                });

            },
        }
    }

</script>



<style scoped>



</style>
